/* eslint-disable functional/prefer-readonly-type */
import { FC } from "react";
import { createPortal } from "react-dom";
import { ToastBanner } from "./ToastBanner";
import { useToastsValue } from "../../app/hooks/useToastsValue";
import { removeDuplicate } from "../miscellaneous/removeDuplicate";
import { Toast } from "../miscellaneous/toastsAtom";

export const Toasts: FC = () => {
  const toasts = useToastsValue();
  const toastElement = document.getElementById("mkhc-toast");

  // Below is error code isn't need to show on Toasts component.
  // Because these errors is handle show by SampleExceededBanners component.
  const errorsNotShowOnToasts = [
    "SampleCountExceeded",
    "SampleLineValueExceeded",
    "SampleLineCountExceeded",
  ];

  const uniqueToastMessage = removeDuplicate<Toast>(
    toasts as Toast[],
    "joiningKey"
  );

  const removeMessageRedundantly = (uniqueToastMessage ?? []).filter((item) => {
    return !errorsNotShowOnToasts.includes(item.joiningKey as string);
  });

  return toastElement === null || toasts === null
    ? null
    : createPortal(
        <div className="tw-flex tw-flex-col tw-gap-1 tw-bg-white">
          {removeMessageRedundantly?.map((toast: Toast) => {
            return <ToastBanner key={toast.joiningKey} toast={toast} />;
          })}
        </div>,
        toastElement
      );
};
